import Vue from "vue";

const $ = require("jquery");
require("bootstrap");

Vue.directive("tooltip", {
  bind(el, binding) {
    $(el).tooltip({
      title: binding.value,
      placement: binding.arg || "top",
      trigger: "hover",
      container: "body"
    });
  },
  update(el, binding) {
    $(el).tooltip("dispose").tooltip({
      title: binding.value,
      placement: binding.arg || "top",
      trigger: "hover",
      container: "body"
    });
  },
  unbind(el) {
    $(el).tooltip("dispose");
  }
});
